import { useQuery, UseQueryOptions } from 'react-query'
import { Api } from 'types/Api'
import { contentfulClient } from 'services/ApiClient'
import { ContentfulCollection, Tag } from 'contentful'

export namespace FetchBlogTags {
  export type Response = ContentfulCollection<Tag>
  export type Error = Api.Error
  export type Options = UseQueryOptions<Response, Error>
}

const createKey = () => ['tags']

const queryFetcher = () => () => {
  return contentfulClient.getTags()
}

export const useFetchBlogTags = (options?: FetchBlogTags.Options) => {
  return useQuery<FetchBlogTags.Response, FetchBlogTags.Error>(createKey(), queryFetcher(), options)
}
